import React, { useState, useMemo, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AntdTableExample from "../../../input-components/dataTable";
import SubNav from "../../../navbar/subNav";
import { format } from "date-fns";
import { UploadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { GetCookie } from "../../../../components/CommonSection/Cookie/Session";
import { makeRequestWithSpinner } from "../../../../Utilities/client";
import { uploadbankfile,reconcilebankfile} from "../../../../components/CommonSection/apiresources";
import ToastAlert from "../../../../components/CommonSection/ToastAlert/ToastAlert";
import { useSpinnerContext } from "../../../../Utilities/SpinnerContext";
import { ActionStatus } from "../../../../Utilities/enum";
import { dynamicUrl } from "../../../../Utilities/profileManagement";

const BankImportPreview = () => {
    const [agencyID, setAgencyId] = useState("");
    const [rows, setRows] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [bankData, setBankData] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();
    const fileName = location.state?.fileName || "Imported Bank Transactions";
    const fileid = location.state?.fileId || 0;
    const [fileId,setFileId] = useState(fileid)
    const inputRef = useRef();
    const ToastRef = useRef();
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [fileMeta, setFileMeta] = useState({
        fileName: "",
        fileDate: "",
        balance: 0,
        alreadyUploaded: false,
    });

    useEffect(() => {
        const userData = GetCookie("@UserData");
        if (userData) {
            const parsedData = JSON.parse(userData);
            setAgencyId(parsedData.agencyID);
        }
        // Initialize bankData from route state
        if (location.state?.bankData) {
            setBankData(location.state.bankData);
        }
    }, []);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.addEventListener('change', handleFileUpload);
        }
        return () => {
            if (inputRef.current) {
                inputRef.current.removeEventListener('change', handleFileUpload);
            }
        };
    }, [agencyID]);

    
    const handlePageChange = (pageNumber, totalRows) => {
        setCurrentPage(pageNumber);
        setRows(totalRows);
    };

    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = async () => {
            const base64Content = reader.result.split(',')[1];
            const payload = {
                FileName: file.name,
                AgencyId: agencyID,
                File: base64Content,
            };

            try {
                const res = await makeRequestWithSpinner(showSpinner, hideSpinner, uploadbankfile, "post", payload);

                if (res.status === ActionStatus.Successfull) {
                    const { transactions, fileName, fileDate, alreadyUploaded } = res.object;
                    setBankData(transactions);
                    setFileMeta({
                        fileName,
                        fileDate,
                        balance: transactions.reduce((sum, t) => sum + t.amount, 0),
                        alreadyUploaded,
                    });
                    setFileId(res.object.id)
                    ToastRef.current.notify(["success", "Bank file imported successfully"]);
                } else {
                    ToastRef.current.notify(["error", res.message]);
                }
            } catch (err) {
                ToastRef.current.notify(["error", "Error uploading bank file"]);
            }
        };

        reader.readAsDataURL(file);
    };

    const bankFileData = useMemo(() => {
        return bankData.map((entry, index) => ({
            date: format(new Date(entry.datePosted), "yyyy-MM-dd"),
            type: entry.type,
            description: entry.memo,
            debit: entry.type === "DEBIT" ? `$${Math.abs(entry.amount).toFixed(2)}` : "",
            credit: entry.type === "CREDIT" ? `$${entry.amount.toFixed(2)}` : ""
        }));
    }, [bankData]);


    const handleReconsile = async () => {
        try {
            const data = { FileId: fileId};
            const response = await makeRequestWithSpinner(showSpinner, hideSpinner, reconcilebankfile, "post", data);

            if (response.status === ActionStatus.Successfull) {
               dynamicUrl(navigate, `ReconcileTransaction?fileId=${fileId}`);
            } else {
                ToastRef.current.notify(["error", response.message]);
            }
        } catch (error) {
            ToastRef.current.notify(["error", error.message || "An unexpected error occurred"]);
        }
    };

    

    return (
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 changedateantdstyle">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 daily-date-style">
                <SubNav title={"Upload Bank File"} goback={true} extraData={true} extraContent={
                    <div className="property-details-buttons">
                        <button className="main-subnav-btn" onClick={handleReconsile}>
                            Reconcile Transaction
                        </button>
                    </div>
                } />
                <ToastAlert ref={ToastRef} />
                <div className="material-work-desk-new bg-white m-3">
                    <div className="mb-3">
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <strong>File Name:</strong> {fileMeta.fileName}
                            </div>
                            <div>
                                <strong>Balance:</strong> ${fileMeta.balance.toFixed(2)}
                            </div>
                            <div>
                                <strong>Balance Date:</strong> {fileMeta.fileDate ? format(new Date(fileMeta.fileDate), 'd MMM yyyy') : ""}
                            </div>
                        </div>
                        {fileMeta.alreadyUploaded && (
                            <div style={{ color: "orangered", fontSize: "13px" }}>This file has been imported previously</div>
                        )}
                    </div>

                    <div>
                        <Button className="mr-2 withdraw-btn" type="default" icon={<UploadOutlined />} onClick={() => inputRef.current.click()}>
                            Choose another file
                        </Button>
                    </div>
                    {bankData?.length ? (
                        <AntdTableExample
                            showCheckbox={false}
                            label={fileName}
                            dataSource={bankFileData}
                            hideCol={""}
                            globalSearch
                            onPageChange={handlePageChange}
                            currentPage={currentPage}
                            totalRows={rows}
                            totalRecords={bankFileData.length}
                        />
                    ) : (
                        <p>No data available.</p>
                    )}
                </div>
                <input
                    type="file"
                    accept=".ofx"
                    style={{ display: 'none' }}
                    ref={inputRef}
                />
               
            </div>
        </div>
    );
};

export default BankImportPreview;
